import React from 'react'
import withComposedClassName from 'src/composables/withComposedClassName'
import { FormattedMessage } from 'react-intl'

import styles from './Badge.module.scss'

const Root = withComposedClassName(styles.root)('span')

const BadgeText = withComposedClassName(styles.text)('span')

const Badge = ({ children, ...restProps }) => (
  <Root {...restProps}>
    <BadgeText> {children} </BadgeText>
  </Root>
)

export const Primary = withComposedClassName(styles.primary)(Badge)

export const New = props => (
  <Primary {...props}>
    <FormattedMessage id='Navigation.badge.newLink' defaultMessage='New' />
  </Primary>
)

export default Badge
